export default "__VITE_ASSET__BuvM5kYU__"